import { useState } from "react";

import { fetchJSON } from "lib/fetch";
import { getConfig } from "site-config";

import { TAPIResponse } from "../types";
import { API_STATES, createAuthHeader } from "../helpers";
import { showAPIExceptionMessage } from "../api-exception-messages";

export type TUpdateOrderProductsRelationsResponse = {
    upsert: "success";
};

type TUpdateOrderProductsRelationsParams = {
    itemMappings: {
        nuOrderItemId: string;
        nuOrderProductId: string;
        rSeriesItemId: number | null;
    }[];
};

type TParams = {
    snackbar: any;
};

type TResponse = TAPIResponse<TUpdateOrderProductsRelationsResponse, string> & {
    updateOrderProductsRelations: (params: TUpdateOrderProductsRelationsParams) => void;
};

export const useUpdateOrderProductsRelations = ({ snackbar }: TParams): TResponse => {
    const { RSERIES_MARKETPLACE_DATA_FLOW_BASE_URL } = getConfig();

    const [state, setState] = useState<TAPIResponse<TUpdateOrderProductsRelationsResponse, string>>(API_STATES.default);

    const APIStates = API_STATES.getStates(setState);

    const updateOrderProductsRelations = (params: TUpdateOrderProductsRelationsParams) => {
        APIStates.pending();

        fetchJSON<TUpdateOrderProductsRelationsResponse>(
            `${RSERIES_MARKETPLACE_DATA_FLOW_BASE_URL}/product-relations`,
            {
                method: "PUT",
                headers: createAuthHeader(),
                body: JSON.stringify(params),
            }
        )
            .then(APIStates.success)
            .catch((error) => {
                showAPIExceptionMessage({ snackbar });
                APIStates.error(error);
            });
    };

    return {
        ...state,
        updateOrderProductsRelations,
    };
};
